export default "__VITE_ASSET__CtIWFCxH__"